/**
 * Token do link de acesso sem login que vai nos avisos de cobrança do portal do assinante
 * (`/subscriptions?next=...&acesso=<token>`).
 *
 * O token abre uma assinatura sem código, então não pode ficar na URL: o histórico guarda, e o
 * Google Tag Manager registra a página com a query inteira. O bootstrap do `public/index.html` o
 * tira dali antes do GTM carregar e deixa aqui no window; este módulo o recolhe na avaliação do
 * bundle. A tela inicial do portal ainda olha a URL, para o bootstrap que falhou e para a navegação
 * que chegou pelo router.
 */

export const SUBSCRIBER_LINK_TOKEN_PARAM = 'acesso';

export const SUBSCRIBER_LINK_TOKEN_WINDOW_KEY = '__CAKTO_SUBSCRIBER_LINK_TOKEN__';

const takeBootstrapToken = () => {
  const token = window[SUBSCRIBER_LINK_TOKEN_WINDOW_KEY];

  try {
    delete window[SUBSCRIBER_LINK_TOKEN_WINDOW_KEY];
  } catch (_error) {
    window[SUBSCRIBER_LINK_TOKEN_WINDOW_KEY] = undefined;
  }

  return typeof token === 'string' && token ? token : null;
};

// Fora do window na carga do bundle, como os tokens de login (`querySessionTokens`): a tela do
// portal é lazy, e esperar o chunk dela deixaria o token legível por nome a qualquer script.
let pendingBootstrapToken = typeof window === 'undefined' ? null : takeBootstrapToken();

/**
 * Lê sem consumir. Quem lê é o inicializador de estado da tela, que o StrictMode chama duas vezes
 * no mesmo render; consumir na primeira deixaria a segunda sem token.
 */
export const peekSubscriberLinkToken = (searchParams) =>
  pendingBootstrapToken || searchParams?.get(SUBSCRIBER_LINK_TOKEN_PARAM) || null;

/** O token vale uma troca: depois dela, outra montagem da tela não pode achá-lo de novo. */
export const discardSubscriberLinkToken = () => {
  pendingBootstrapToken = null;
};

/** A query sem o token, com o `next` e o resto. */
export const withoutSubscriberLinkToken = (searchParams) => {
  const next = new URLSearchParams(searchParams);
  next.delete(SUBSCRIBER_LINK_TOKEN_PARAM);
  return next;
};
